<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="min-h-screen bg-gray-50" style="min-width: 100vw;">
    <!-- 顶部导航栏 - 固定位置 -->
    <nav
      class="fixed top-0 w-full bg-gradient-to-r from-purple-600 to-blue-500 text-white h-14 flex items-center px-4 z-50">
      <button class="text-white" @click="cancelPay">
        <i class="iconfont fa-arrow-left text-lg"></i>
      </button>
      <h1 class="text-lg font-bold tracking-wider flex-1 text-center">
        收银台
      </h1>
    </nav>

    <!-- 可滚动的内容区域 -->
    <div class="content-scroll-area pt-16 pb-20 px-4 overflow-y-auto">
      <!-- 顶部额外留白 -->
      <div class="h-2"></div>

      <!-- 订单信息 -->
      <div class="bg-white rounded-lg p-4 mb-4 shadow-sm">
        <h2 class="text-gray-600 mb-3">订单信息</h2>
        <div class="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-4 mb-4">
          <div class="text-center">
            <span class="text-sm text-gray-500">支付金额</span>
            <p
              class="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-500 mt-1">
              ¥ {{ orderData.amount || 0 }}
            </p>
          </div>
        </div>
        <div class="space-y-2 text-sm">
          <div class="flex justify-between">
            <span class="text-gray-500">订单号</span>
            <span>{{ orderData.orderId }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-500">创建时间</span>
            <span>{{ orderData.createTime }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-500">订单来源</span>
            <span>猫空趣游</span>
          </div>
        </div>
      </div>

      <!-- 充值金额 -->
      <div class="bg-white rounded-lg p-6 mb-4 shadow-lg relative overflow-hidden">
        <img src="https://ai-public.mastergo.com/ai/img_res/1e5ef6e77ff6342a5d5d878d70d1f9ac.jpg"
          class="absolute inset-0 w-full h-full object-cover opacity-90" alt="background" />
        <!-- 优惠标签 -->
        <div class="absolute top-4 right-4">
          <div
            class="bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold px-3.5 py-1.5 rounded-full shadow-xl animate-pulse border-2 border-white/30 backdrop-blur-sm">
            <i class="iconfont fa-shandian mr-1 text-xs"></i>
            限时特惠
          </div>
        </div>
        <!-- 内容容器 -->
        <div class="relative z-10">
          <!-- 标题部分 -->
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center mr-3">
              <i class="iconfont fa-crown text-2xl text-yellow-400"></i>
            </div>
            <div>
              <h3 class="text-white text-lg font-bold" style="text-align: left;">{{ payInfo.title || '超值福利套餐' }}</h3>
              <p class="text-white/70 text-sm">解锁全部游戏特权</p>
            </div>
          </div>
          <!-- 游戏币数量 -->
          <div class="bg-white/10 backdrop-blur-md rounded-xl p-4 mb-4">
            <div class="flex items-baseline justify-center">
              <i class="iconfont fa-coins text-yellow-400 mr-2"></i>
              <span class="text-4xl font-bold text-white">{{ payInfo.amount }}</span>
              <span class="text-white/90 ml-2">金币</span>
            </div>
          </div>
          <!-- 福利列表 -->
          <!-- grid-cols-2 gap-3 -->
          <div class="grid ">
            <!-- <div class="bg-white/10 backdrop-blur-md rounded-xl p-3 text-center">
              <i class="iconfont fa-gift text-yellow-400 mb-1"></i>
              <p class="text-white text-sm">{{payInfo.desc}}</p>
            </div> -->
            <div class="bg-white/10 backdrop-blur-md rounded-xl p-3 text-center">
              <!-- <i class="iconfont fa-star text-yellow-400 mb-1"></i> -->
              <p class="text-white text-sm">{{ payInfo.detail || payInfo.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付方式 -->
      <div class="bg-white rounded-lg p-4 mb-4 shadow-sm">
        <h2 class="text-gray-600 mb-3">支付方式</h2>
        <div class="space-y-3">
          <!-- 微信支付 - 仅在微信环境显示 -->
          <div v-if="isWechat"
            :class="selectedPayment === 'wechat' ? 'border-purple-500 bg-gradient-to-r from-purple-50 to-blue-50' : 'border-blue-50'"
            class="border-2 rounded-lg p-4 flex items-center cursor-pointer transform transition-transform hover:scale-102 hover:shadow-md"
            @click="selectPaymentMethod('wechat')">
            <div class="flex flex-1 items-center">
              <i class="iconfont fa-weixin text-2xl text-green-500 mr-2"></i>
              <div>
                <p class="font-medium" style="text-align: left;">微信支付</p>
                <p class="text-sm text-gray-500">支持微信零钱和银行卡</p>
              </div>
            </div>
            <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center"
              :class="selectedPayment === 'wechat' ? 'border-purple-500' : 'border-blue-50'">
              <div v-if="selectedPayment === 'wechat'"
                class="w-4 h-4 rounded-full bg-gradient-to-r from-purple-500 to-blue-500"></div>
            </div>
          </div>

          <!-- 支付宝 - 非微信环境下显示 -->
          <div v-if="!isWechat"
            :class="selectedPayment === 'alipay' ? 'border-purple-500 bg-gradient-to-r from-purple-50 to-blue-50' : 'border-blue-50'"
            class="border-2 rounded-lg p-4 flex items-center cursor-pointer transform transition-transform hover:scale-102 hover:shadow-md"
            @click="selectPaymentMethod('alipay')">
            <div class="flex flex-1 items-center">
              <i class="iconfont fa-alipay text-2xl text-blue-500 mr-2"></i>
              <div>
                <p class="font-medium" style="text-align: left;">支付宝</p>
                <p class="text-sm text-gray-500">支持余额和银行卡</p>
              </div>
            </div>
            <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center"
              :class="selectedPayment === 'alipay' ? 'border-purple-500' : 'border-blue-50'">
              <div v-if="selectedPayment === 'alipay'"
                class="w-4 h-4 rounded-full bg-gradient-to-r from-purple-500 to-blue-500"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 额外的内容区域 - 可以根据需要添加更多内容 -->
      <!-- <div class="bg-white rounded-lg p-4 mb-4 shadow-sm">
        <h2 class="text-gray-600 mb-3">支付说明</h2>
        <div class="text-sm text-gray-500 space-y-2">
          <p>1. 支付完成后，游戏币将立即到账</p>
          <p>2. 如遇支付问题，请联系客服</p>
          <p>3. 支付成功后，可在游戏内查看充值记录</p>
        </div>
      </div> -->

      <!-- 底部空白区域，确保内容不被底部按钮遮挡 -->
      <div class="h-10"></div>
    </div>

    <!-- 底部按钮 - 固定位置 -->
    <div class="fixed bottom-0 left-0 w-full bg-white px-4 py-3 shadow-lg">
      <button
        class="w-full py-3 bg-gradient-to-r from-purple-700 to-blue-600 text-white font-medium !rounded-button transform transition-transform hover:scale-102"
        :class="{ 'opacity-50': !canPay || payInfo.isCreatingOrder }" :disabled="!canPay || payInfo.isCreatingOrder"
        @click="confirmPay">
        <span v-if="payInfo.isCreatingOrder">订单创建中...</span>
        <span v-else>确认支付</span>
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { payAPI } from '@/services/api';
import wx from "weixin-js-sdk";

export default {
  name: 'PayView',
  props: {
    payInfo: {
      type: Object,
      default: () => ({
        amount: '100.00',
        orderId: '202403150001928',
        orderTime: '2024-03-15 14:30:25',
        source: '猫空趣游',
        productId: '',
        isCreatingOrder: false
      })
    }
  },
  data() {
    return {
      selectedPayment: 'alipay', // 默认选择支付宝支付
      agreeProtocol: true,
      isWechat: false,
      paymentResult: {
        success: false,
        message: '',
        transactionId: ''
      },
      isProcessing: false,
      orderData: null
    }
  },
  computed: {
    canPay() {
      return this.selectedPayment && this.agreeProtocol && !this.isProcessing && this.orderData;
    }
  },
  methods: {
    // 设置订单数据
    setOrderData(orderData) {
      let createTime = new Date(orderData.createTime)
      orderData.createTime = `${createTime.getFullYear()}-${createTime.getMonth() + 1}-${createTime.getDate()}`
      this.orderData = orderData;
      // 通知父组件订单已创建
      this.$emit('order-created', orderData);
    },

    // 选择支付方式
    selectPaymentMethod(method) {
      if (this.selectedPayment !== method) {
        this.selectedPayment = method;
        // 通知父组件支付方式变更
        this.$emit('payment-method-change', method);
      }
    },

    // 检测是否在微信浏览器中
    checkWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWechat = /micromessenger/.test(ua);
      console.log('是否在微信浏览器中:', this.isWechat);

      // 如果在微信环境中，选择微信支付
      if (this.isWechat) {
        this.selectPaymentMethod('wechat');
      } else {
        // 非微信环境中，选择支付宝支付
        this.selectPaymentMethod('alipay');
      }
    },

    // 处理触摸移动事件
    handleTouchMove(e) {
      // 允许内容区域滚动
      const scrollArea = document.querySelector('.content-scroll-area');
      if (scrollArea && !scrollArea.contains(e.target)) {
        e.preventDefault();
      }
    },

    // 确认支付
    async confirmPay() {
      if (!this.canPay) return;

      this.isProcessing = true;

      try {
        // 订单已经创建，直接处理支付
        this.handlePay(this.orderData);

        // if (this.selectedPayment === 'wechat') {
        //   this.handleWechatPay(this.orderData);
        // } else {
        //   this.handleAlipayPay(this.orderData);
        // }
      } catch (error) {
        console.error('支付处理出错:', error);
        Toast.fail('网络错误，请稍后重试');
        this.isProcessing = false;
      }
    },

    // 处理支付
    async handlePay(orderData) {
      const response = await payAPI.pay({
        orderId: orderData.orderId,
        payChannel: this.selectedPayment === 'wechat' ? 4 : 3, // 4-微信支付，3-支付宝支付
        paymentType: this.selectedPayment === 'wechat'? 'WECHAT_H5' : 'ALIPAY_WAP', // 1-微信H5支付，2-支付宝H5支付
        // returnUrl: window.location.origin + '/#/success' // 支付成功后跳转的页面
      })
      console.log('aaa', response)
      if (response.data.data) {
        this.isProcessing = false;
        if (this.selectedPayment === 'wechat') {
          // this.callWechatJSAPI(response.data.data.wechatAppParams)
        } else {
          localStorage.removeItem("alipay");
          if (!response.data.data.success) {
            Toast.fail(response.data.data.errorMsg || '获取支付链接失败');
            return 
          }
          this.$emit('alipay', response.data.data.detail.form, response.data.data.orderId)
          // this.$emit('alipay', response.data.data.alipayH5Form)
        }
       
      } else {
        Toast.fail('获取支付链接失败');
        this.isProcessing = false;
        this.$emit('close', this.paymentResult);
      }
    },

    // 处理微信支付
    handleWechatPay(orderData) {
      // 微信环境中直接调用JSAPI支付
      if (this.isWechat) {
        this.callWechatJSAPI(orderData);
      } else {
        // 非微信环境中提示用户
        Toast('请在微信中打开进行支付');
        this.isProcessing = false;
      }
    },

    // 调用微信JSAPI支付
    callWechatJSAPI(orderData) {
      Toast.loading({
        message: '正在拉起支付...',
        forbidClick: true,
        duration: 0
      });

      // 获取支付参数
      const payParams = orderData.payParams;

      // 确保WeixinJSBridge已加载
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(payParams), false);
        }
      } else {
        this.onBridgeReady(payParams);
      }
      // this.wexinPay()
    },

    wexinPay() {
      //发起微信支付
      wx.config({
        debug: false, // 开启调试模式
        // appId: appId, // 必填，公众号的唯一标识
        // timestamp: timestamp, // 必填，生成签名的时间戳
        // nonceStr: nonceStr, // 必填，生成签名的随机串
        // signature: signature, // 必填，签名
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: '', // 支付签名时间戳
          nonceStr: '', // 支付签名随机串，不长于 32 位
          package: '', // 统一支付接口返回的prepay_id参数值，提交格式如： prepay_id=***）
          signType: '', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: '', // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            cb(res);
          },
          fail: function (res) {
            //失败回调函数
            errorCb(res);
          }
        });
      });
      wx.error(function (res) {
        /*alert("config信息验证失败");*/
      });
    },

    // 微信JSAPI支付回调
    onBridgeReady(payParams) {
      Toast.clear();

      // 调用微信支付
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        payParams,
        (res) => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 支付成功
            this.handlePaymentSuccess({
              paymentMethod: 'wechat',
              message: '微信支付成功'
            });
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            // 用户取消
            Toast('支付已取消');
            this.isProcessing = false;
          } else {
            // 支付失败
            Toast.fail('支付失败，请重试');
            this.isProcessing = false;
          }
        }
      );
    },

    // 处理支付宝支付
    async handleAlipayPay(orderData) {
      // Toast.loading({
      //   message: '正在跳转支付宝...',
      //   forbidClick: true,
      //   duration: 0
      // });

      const response = await payAPI.aliBuy({ productId: this.payInfo.productId })

      console.log('支付', response)

      // 跳转到支付宝支付页面
      if (response.data.data) {
        // 实际项目中应该跳转到支付宝支付页面
        // localStorage.setItem('alipay', 1);
        // const div = document.createElement('div');
        // div.innerHTML = (response.data.data);  //res.data是返回的表单
        // document.body.appendChild(div);
        // document.forms[0].submit();
        // this.$emit('close', this.paymentResult);
        // window.location.href = payUrl;
        this.$emit('alipay', response.data.data)
      } else {
        Toast.fail('获取支付链接失败');
        this.isProcessing = false;
      }

      // 模拟支付成功（实际项目中应该在支付回调页面处理）
      // setTimeout(() => {
      //   Toast.clear();
      //   this.handlePaymentSuccess({
      //     paymentMethod: 'alipay',
      //     message: '支付宝支付成功'
      //   });
      // }, 2000);
    },

    // 修改支付成功处理
    handlePaymentSuccess(result) {
      this.paymentResult = {
        success: true,
        message: result.message || '支付成功',
        transactionId: `TX${Date.now()}`,
        ...result
      };

      Toast.success(this.paymentResult.message);
      this.isProcessing = false;

      // 延迟关闭，让用户看到成功提示
      setTimeout(() => {
        this.$emit('close', this.paymentResult);
      }, 1500);
    },

    cancelPay() {
      if (this.isProcessing) {
        Toast('正在处理支付，请稍候...');
        return;
      }
      this.$emit('close', { success: false, cancelled: true });
    }
  },
  created() {
    // 检测是否在微信浏览器中
    this.checkWechatBrowser();
  },
  mounted() {
    // 防止iOS设备上的滚动问题
    document.body.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeDestroy() {
    // 移除事件监听器
    document.body.removeEventListener('touchmove', this.handleTouchMove);
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 2px solid #4a90e2;
  border-radius: 4px;
  appearance: none;
  cursor: pointer;
}

input[type="checkbox"]:checked {
  background-color: #4a90e2;
  position: relative;
}

input[type="checkbox"]:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* 添加滚动区域样式 */
.content-scroll-area {
  -webkit-overflow-scrolling: touch;
  /* 为iOS设备提供平滑滚动 */
  overscroll-behavior: contain;
  /* 防止滚动传播到父元素 */
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 56px;
  /* 底部按钮的高度 */
  /* padding-bottom: 60px;  */
  /* 确保内容不被底部按钮遮挡 */
}

.text-white {
  color: #fff;
}

.border-blue-50 {
  border-color: var(--color-blue-50);
}

.text-2xl {
  font-size: 1.5rem;
}

.shadow-sm {}
</style>
